




















































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import * as Y from 'yjs'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import SlidesEditorMenu from 'components/presenter/item/topic/editor/SlidesEditorMenu.vue'
import SlidesEditorForm from 'components/presenter/item/topic/editor/SlidesEditorForm.vue'
import SlidesEditorGroup from 'components/presenter/item/topic/editor/SlidesEditorGroup.vue'
import SlidesEditorGrid from 'components/presenter/item/topic/editor/SlidesEditorGrid.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    SlidesEditorMenu,
    SlidesEditorForm,
    SlidesEditorGroup,
    SlidesEditorGrid
  }
})
export default class ItemTopicSlidesEditor extends Vue {
  slides: Json[] = []
  gridSlides: Json[] = []
  slide: Json = {}
  groups: Json = {}
  group: Json = {}
  reorder = false
  selected: Set<Json> | null = null

  @Prop()
  readonly item!: Item

  @Ref()
  readonly editSlideDialog!: DialogFullscreen

  @Ref()
  readonly editGroupDialog!: DialogFullscreen

  get corrects () {
    return this.item.data?.corrects || {}
  }

  @Watch('item.data', { immediate: true, deep: true })
  init (data: Json) {
    this.slides =
      (Object.values(data?.slides || {}) as Json[])
        .filter(x => x.id && !x.deleted)
          .sort((a, b) => a.sort - b.sort)
    this.groups = data?.slides?.groups || {}
  }

  @Watch('slides', { immediate: true })
  gridSlidesSet (slides: Json[]) {
    this.gridSlides =
      slides
        .filter(slide => slide.type !== 'Params')
          .reduce(
            (result: Json[], slide: Json) => [
              ...result,
              ...(
                slide.meta?.pages
                  ? slide.meta.pages
                    .filter((page: Json) => !page.deleted)
                      .map(
                        (page: Json, index: number) =>
                          Object.assign({}, slide, page, {
                            id: `${slide.id}.meta.pages[${index}]`,
                            meta: { masterSlide: slide, masterSlidePageIndex: index }
                          })
                      )
                  : [slide]
              )
            ],
            [] as Json[])
            .sort((a, b) => a.sort - b.sort)
  }

  editGroup (slide: Json) {
    this.group = Object.assign(this.groups[slide.group] || {}, { id: slide.group })
    this.editGroupDialog.show()
  }

  editSlide (slide: Json) {
    this.slide = slide.meta?.masterSlide ? Object.assign(slide.meta.masterSlide, { pageNo: slide.pageNo }) : slide
    this.editSlideDialog.show()
  }

  async save (slides: Json[], name: string, value: any) {
    const slidesSettings: Json = {}
    for (const slide of slides) {
      slidesSettings[`${slide.id}:${name}`] = value || null
    }
    this.item.data?.save({ slidesSettings })
  }
}
